import './App.scss'
import { useEffect } from 'react'
import { getCurrentLanguageInfos } from '@/controller/languageHelper.ts'

function App() {
  useEffect(() => {
    window.location.replace(getCurrentLanguageInfos().shopHomepage)
  }, []);

  return (
    <>
      Weiterleitung zur Website erfolgt
    </>
  )
}

export default App
